import cn from "classnames";
import BookIndex from "components/shared/book/list";
import InlineBtn from "components/shared/inlineBtn";
import SharedReactTable from "components/shared/reactTable";
import Select from "components/shared/select";
import { counterpartyInsolvencyTooltip, counterpartyStatusBadge } from "helpers/bid";
import { counterpartyStatuses } from "helpers/enums";
import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { EnumColumnFilter, isDeletedColumn, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { ymEvent } from "helpers/system";
import without from "lodash/without";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { list as counterpartyGroupsList, setGroupForCounterparties } from "sources/books/counterpartyGroups";
import CheckCounterparty from "./checkCounterparty";

const AddCounterpartiesToGroup = (props) => {
    const [groupId, setGroupId] = useState();
    const [loading, setLoading] = useState(false);
    const sendReq = () => {
        setLoading(true);
        setGroupForCounterparties({ counterpartyGroupId: groupId, counterpartyIds: props.counterpartyIds }).then(() => {
            setLoading(false);
            props.back();
            props.callback();
        });
    };
    return (
        <div className={loading ? "loading" : ""}>
            <div className="form-group">
                <Select
                    url={counterpartyGroupsList}
                    inputProps={{ name: "groupId" }}
                    propName="name"
                    menuPortalTarget={document.body}
                    value={groupId}
                    onChange={({ value }) => setGroupId(value)}
                />
            </div>
            <div className="d-flex justify-content-end">
                {groupId && (
                    <div className="btn btn-sm btn-brand" onClick={sendReq}>
                        Сохранить
                    </div>
                )}
            </div>
        </div>
    );
};

class CargoOwnersList extends BookIndex {
    state = { selectedItems: [], tableColumns: this.tableColumns };

    get tableColumns() {
        const columns = [
            {
                Header: () => {
                    const allItemsSelected = this.state.selectedItems.length === this.props.items.length;
                    return (
                        <div className="d-flex justify-content-center pt-1">
                            <span
                                className={cn("checkbox", { "checkbox--checked": allItemsSelected })}
                                onClick={() =>
                                    allItemsSelected
                                        ? this.setState({ selectedItems: [] })
                                        : this.setState({ selectedItems: this.props.items.map((x) => x.id) })
                                }
                            />
                        </div>
                    );
                },
                accessor: "checkbox",
                width: 30,
                sortable: false,
                Cell: ({
                    row: {
                        original: { id },
                    },
                }) => {
                    const itemSelected = this.state.selectedItems.includes(id);
                    return (
                        <div className="d-flex justify-content-center pt-1">
                            <span
                                className={cn("checkbox", { "checkbox--checked": itemSelected })}
                                onClick={() =>
                                    itemSelected
                                        ? this.setState({ selectedItems: without(this.state.selectedItems, id) })
                                        : this.setState({ selectedItems: this.state.selectedItems.concat(id) })
                                }
                            />
                        </div>
                    );
                },
            },
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) =>
                    this.props.roles.isTruckingOrganizationDispatcher ? (
                        hiddenUserData(null, { type: "title" }, true)
                    ) : (
                        <Link to={paths.cargoOwnersShow(id)}>{value}</Link>
                    ),
            },
            {
                Header: "ИНН",
                accessor: "inn",
                filterable: true,
                Cell: ({ value }) =>
                    hiddenUserData(value, { type: "docNumber" }, this.props.roles.isTruckingOrganizationDispatcher),
            },
            {
                Header: "КПП",
                accessor: "kpp",
                filterable: true,
                Cell: ({ value }) =>
                    hiddenUserData(value, { type: "docNumber" }, this.props.roles.isTruckingOrganizationDispatcher),
            },
            {
                Header: "Статус",
                accessor: "status",
                filterable: true,
                filterType: "onlyInsolventEnum",
                Filter: (props) => (
                    <EnumColumnFilter
                        {...props}
                        filterEnum={[...counterpartyStatuses, { label: "Неплатежеспособный", value: "onlyInsolvent" }]}
                    />
                ),

                Cell: ({ value, row: { original } }) => (
                    <>
                        {counterpartyStatusBadge(value, true)}
                        {original.insolvencyRegistryEntry &&
                            original.insolvencyRegistryEntry.insolvencyRank > 0 &&
                            counterpartyInsolvencyTooltip(original.insolvencyRegistryEntry, this.props.modal)}
                    </>
                ),

                CSVExport: ({ value }) => value,
            },
            {
                Header: "Группа",
                accessor: "counterpartyGroupName",
                id: "counterpartyGroupId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: counterpartyGroupsList,
                            inputProps: { name: "counterpartyGroupId" },
                            propName: "name",
                        }}
                    />
                ),

                Cell: ({
                    value,
                    row: {
                        original: { counterpartyGroupId },
                    },
                }) => (
                    <Link
                        to={paths.counterpartyGroupsShow(counterpartyGroupId)}
                        className="badge badge-pill badge-primary"
                    >
                        {value}
                    </Link>
                ),

                CSVExport: ({ value }) => value,
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: true,
            },
            isDeletedColumn(this.restore, this.props.canEditBooks),
        ];

        return columns;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.canEditBooks !== this.props.canEditBooks) {
            this.setState({ tableColumns: this.tableColumns });
        }
    }

    checkCounterparty = () => {
        ymEvent("CounterpartyCheckClick");
        this.props.modal({
            name: "default",
            title: "Проверить контрагента",
            windowMod: "wide",
            CustomBody: CheckCounterparty,
        });
    };

    renderActions = () => {
        const { mergeParams } = this.props;
        const actions = [
            { value: "Обновить", cname: "refresh", active: true, action: mergeParams, params: {} },
            {
                value: "Проверить контрагента",
                cname: "search",
                active: true,
                action: this.checkCounterparty,
                params: {},
            },
        ];

        if (this.state.selectedItems.length > 0) {
            actions.unshift({
                value: "Добавить выбранные контрагенты в группу",
                cname: "plus",
                active: true,
                action: this.addItemsToGroup,
                params: {},
            });
        }
        return actions.map((item, index) => <InlineBtn key={index} {...item} />);
    };

    addItemsToGroup = () => {
        this.props.modal({
            name: "default",
            title: "Выберите группу",
            CustomBody: AddCounterpartiesToGroup,
            bodyData: { counterpartyIds: this.state.selectedItems, callback: () => this.props.mergeParams({}) },
        });
    };

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">
                        {this.props.roles.isTruckingOrganizationAdmin && (
                            <>
                                <Link className="btn btn-secondary btn-sm mr-2" to={paths.legalPersons}>
                                    Организации
                                </Link>
                                <Link className="btn btn-secondary btn-sm mr-2" to={paths.counterpartyGroups}>
                                    Управление группами
                                </Link>
                            </>
                        )}
                        {this.props.canEditBooks && this.renderCreateButton()}
                    </div>
                </div>
            </div>
        );
    };

    renderCreateButton = () => {
        const { modal, createBtnText, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "createCargoOwner",
                windowMod: "wide",
                title: "Создание контрагента",
                profile: this.props.profile,
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                {createBtnText}
            </a>
        );
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };
}

export default tableContainer(CargoOwnersList, "cargoowners");
